var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 129,
    viewBox: "0 0 146 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5135 7.59687C80.5135 7.59687 68.3761 34.8388 36.2782 28.5982C4.1804 22.3575 -15.1585 66.263 15.1873 82.2719C45.5331 98.2808 24.5027 116.671 44.7412 126.065C67.7438 136.741 76.3215 101.041 93.2677 104.357C130.669 111.675 153.804 99.1241 143.574 82.2345C125.617 52.5869 112.578 53.6784 117.877 34.5328C123.176 15.3871 93.2522 -14.0047 80.5135 7.59687Z",
    fill: "#DBF1FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8318,
    cy: 41.8898,
    r: 16,
    fill: "#0884CC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.028,
    cy: 30.1026,
    r: 9.38674,
    fill: "#0884CC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.028,
    cy: 65.0598,
    r: 9.38674,
    fill: "#0884CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7861 45.0204C53.3177 47.7585 49.3763 49.4211 44.9857 48.7354C40.5911 48.049 37.4091 45.2738 37.8775 42.5358C37.9667 42.0259 38.1752 41.5418 38.4876 41.1197C38.5729 41.0054 38.7009 40.9267 38.8452 40.8999C38.9894 40.873 39.1389 40.9001 39.263 40.9754C40.836 41.9164 43.3259 42.7462 46.1987 43.1949C48.8426 43.6079 51.2892 43.6141 53.0697 43.2914C53.2147 43.2648 53.3649 43.2926 53.489 43.3689C53.6132 43.4452 53.7018 43.5642 53.7367 43.7012C53.8438 44.1336 53.8606 44.5818 53.7861 45.0204Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1378 39.4099C45.0888 39.41 45.0404 39.3994 44.9959 39.3788C44.9514 39.3583 44.9118 39.3283 44.8801 39.291C44.8483 39.2537 44.8251 39.2099 44.8119 39.1626C44.7988 39.1154 44.7961 39.0659 44.804 39.0175C44.9174 38.3238 44.7505 37.6135 44.3402 37.0428C43.9299 36.4721 43.3096 36.0878 42.6159 35.9744C41.9222 35.861 41.2119 36.0278 40.6412 36.4381C40.0705 36.8485 39.6861 37.4687 39.5728 38.1624C39.5583 38.2509 39.5093 38.3299 39.4365 38.3822C39.3638 38.4345 39.2732 38.4558 39.1848 38.4413C39.0964 38.4269 39.0173 38.3779 38.965 38.3051C38.9127 38.2324 38.8915 38.1418 38.9059 38.0534C39.0482 37.1828 39.5305 36.4045 40.2467 35.8895C40.9629 35.3745 41.8544 35.1652 42.7249 35.3075C43.5955 35.4498 44.3739 35.9321 44.8888 36.6483C45.4038 37.3645 45.6131 38.256 45.4708 39.1265C45.4579 39.2055 45.4173 39.2774 45.3563 39.3293C45.2954 39.3812 45.2179 39.4098 45.1378 39.4099V39.4099Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2421 40.7347C53.1932 40.7347 53.1448 40.724 53.1003 40.7034C53.0558 40.6829 53.0164 40.6529 52.9847 40.6156C52.9529 40.5783 52.9297 40.5345 52.9165 40.4873C52.9033 40.4401 52.9005 40.3907 52.9083 40.3423C53.0189 39.6499 52.8506 38.9418 52.4402 38.3732C52.0298 37.8047 51.4108 37.4219 50.7187 37.3088C50.0267 37.1957 49.318 37.3614 48.748 37.7697C48.1779 38.178 47.7928 38.7956 47.6772 39.4872C47.6702 39.5311 47.6545 39.5732 47.6312 39.6111C47.6079 39.6489 47.5773 39.6818 47.5413 39.7078C47.5052 39.7338 47.4644 39.7524 47.4211 39.7626C47.3778 39.7729 47.333 39.7744 47.2891 39.7672C47.2452 39.7601 47.2032 39.7443 47.1654 39.7209C47.1276 39.6974 47.0949 39.6667 47.069 39.6306C47.0431 39.5945 47.0246 39.5536 47.0145 39.5103C47.0044 39.467 47.003 39.4221 47.0103 39.3782C47.1551 38.5099 47.6381 37.7343 48.3537 37.2216C49.0692 36.7088 49.9589 36.5006 50.8277 36.6426C51.6964 36.7846 52.4735 37.2652 52.9885 37.9792C53.5035 38.6931 53.7145 39.5821 53.5752 40.4514C53.5623 40.5304 53.5217 40.6023 53.4607 40.6542C53.3997 40.7061 53.3222 40.7347 53.2421 40.7347Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0605 79C89.5718 79.0001 91.8429 80.0259 93.4805 81.6797C94.6293 81.1507 95.9072 80.8545 97.2549 80.8545C101.544 80.8545 105.132 83.8432 106.057 87.8516C110.613 88.3144 114.169 92.1624 114.169 96.8408C114.169 101.676 110.371 105.625 105.596 105.866V105.878H80.3408L80.3428 105.849C75.6761 105.495 72 101.598 72 96.8408C72.0002 92.9043 74.5176 89.5571 78.0303 88.3184C78.0274 88.2248 78.0234 88.1304 78.0234 88.0361C78.0237 83.0457 82.0701 79 87.0605 79Z",
    fill: "#0884CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1214 95.4069C89.0512 95.3929 88.9875 95.356 88.9405 95.302C88.8934 95.248 88.8655 95.18 88.8612 95.1085C88.8429 94.4759 88.9373 93.8452 89.14 93.2457C89.5868 91.944 90.5102 91.1055 91.8103 90.8207C92.66 90.6346 93.4029 90.7617 94.0184 91.1989C95.2798 92.0948 95.5196 93.9718 95.5292 94.0512C95.5371 94.1354 95.5118 94.2193 95.4588 94.2851C95.4057 94.3509 95.3291 94.3934 95.2452 94.4035C95.1612 94.4137 95.0767 94.3907 95.0095 94.3394C94.9423 94.2881 94.8977 94.2126 94.8854 94.129C94.8834 94.1128 94.668 92.4538 93.641 91.7265C93.1812 91.4009 92.6121 91.3093 91.9494 91.4545C90.8734 91.6904 90.1369 92.3576 89.7603 93.4379C89.582 93.9632 89.4969 94.5156 89.5091 95.0701C89.514 95.156 89.4847 95.2403 89.4275 95.3046C89.3703 95.3689 89.29 95.4079 89.2041 95.413C89.1764 95.4145 89.1486 95.4124 89.1214 95.4069Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.532 94.1704C98.4653 94.1571 98.4045 94.1232 98.3582 94.0735C98.3118 94.0238 98.2823 93.9608 98.2736 93.8934C98.2138 93.2659 98.2666 92.6328 98.4296 92.0239C98.79 90.7015 99.6563 89.8088 100.935 89.4424C101.772 89.2027 102.523 89.2817 103.166 89.6789C104.48 90.489 104.842 92.3351 104.857 92.4132C104.872 92.4974 104.854 92.5841 104.805 92.6545C104.756 92.7249 104.682 92.7733 104.598 92.7891C104.514 92.805 104.427 92.7871 104.356 92.7393C104.286 92.6914 104.236 92.6176 104.22 92.5337C104.216 92.5176 103.893 90.8875 102.824 90.2298C102.342 89.9338 101.767 89.8788 101.114 90.0662C100.056 90.3692 99.3654 91.0788 99.0608 92.1756C98.9175 92.7085 98.869 93.2624 98.9174 93.812C98.9237 93.863 98.9178 93.9147 98.9002 93.9629C98.8826 94.0112 98.8538 94.0546 98.8162 94.0896C98.7786 94.1245 98.7333 94.1501 98.6839 94.1642C98.6345 94.1782 98.5825 94.1803 98.5321 94.1704L98.532 94.1704Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4687 97.9101C101.601 98.4815 102.847 100.337 102.909 100.43C102.933 100.466 102.949 100.506 102.957 100.548C102.965 100.589 102.965 100.632 102.956 100.674C102.947 100.716 102.931 100.756 102.907 100.791C102.883 100.826 102.852 100.856 102.817 100.88C102.781 100.903 102.741 100.919 102.7 100.928C102.658 100.936 102.615 100.935 102.573 100.927C102.531 100.918 102.492 100.901 102.456 100.878C102.421 100.854 102.391 100.823 102.367 100.788C102.351 100.763 100.704 98.3213 98.0932 98.3941C95.4947 98.4664 94.0161 101.345 94.0014 101.374C93.9623 101.45 93.8948 101.507 93.8136 101.534C93.7324 101.56 93.6441 101.553 93.5677 101.515C93.4914 101.477 93.4333 101.41 93.4059 101.329C93.3785 101.248 93.3841 101.16 93.4215 101.083C93.7401 100.49 94.1369 99.9427 94.6012 99.4555C95.629 98.3715 96.83 97.7802 98.0751 97.7456C98.5452 97.7325 99.0146 97.7879 99.4687 97.9101V97.9101Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.461 27.4933C125.65 27.3038 125.958 27.3038 126.147 27.4933C126.337 27.6829 126.337 27.9903 126.147 28.1799L121.4 32.927C121.21 33.1166 120.903 33.1166 120.713 32.927L118.555 30.7694C118.366 30.5797 118.366 30.2724 118.555 30.0828C118.745 29.8932 119.052 29.8932 119.242 30.0828L121.056 31.8972L125.461 27.4933Z",
    fill: "#FCFCFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.597 62.451C124.787 62.2614 125.094 62.2614 125.284 62.451C125.474 62.6407 125.474 62.948 125.284 63.1376L123.038 65.3838L125.284 67.6299C125.474 67.8195 125.474 68.1269 125.284 68.3165C125.094 68.5061 124.787 68.5061 124.597 68.3165L122.351 66.0703L120.105 68.3165C119.916 68.5061 119.608 68.5061 119.419 68.3165C119.229 68.1269 119.229 67.8195 119.419 67.6299L121.665 65.3838L119.419 63.1376C119.229 62.948 119.229 62.6407 119.419 62.451C119.608 62.2614 119.916 62.2614 120.105 62.451L122.351 64.6972L124.597 62.451Z",
    fill: "#FCFCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.9729,
    y: 45.9626,
    width: 9.06306,
    height: 3.88417,
    rx: 1.94209,
    fill: "#0884CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3152,
    y: 64.0889,
    width: 27.8366,
    height: 1.29472,
    rx: 0.647361,
    transform: "rotate(90 45.3152 64.0889)",
    fill: "#0884CC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1626,
    y: 57.8047,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(134.522 35.1626 57.8047)",
    fill: "#0884CC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.7845,
    y: 15.3557,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(95.1024 48.7845 15.3557)",
    fill: "#0884CC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.4966,
    y: 65.5695,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(-127.643 57.4966 65.5695)",
    fill: "#0884CC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 111.73,
    width: 5.34501,
    height: 2.13921,
    rx: 1.06961,
    transform: "rotate(-62.2536 84 111.73)",
    fill: "#0884CC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 116.73,
    width: 5.34501,
    height: 2.13921,
    rx: 1.06961,
    transform: "rotate(-62.2536 85 116.73)",
    fill: "#0884CC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 111.73,
    width: 5.34501,
    height: 2.13921,
    rx: 1.06961,
    transform: "rotate(-62.2536 90 111.73)",
    fill: "#0884CC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 116.73,
    width: 5.34501,
    height: 2.13921,
    rx: 1.06961,
    transform: "rotate(-62.2536 91 116.73)",
    fill: "#0884CC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 111.73,
    width: 5.34501,
    height: 2.13921,
    rx: 1.06961,
    transform: "rotate(-62.2536 95 111.73)",
    fill: "#0884CC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27.4966,
    y: 32.5695,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(-127.643 27.4966 32.5695)",
    fill: "#0884CC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4921,
    y: 45.9562,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(171.506 26.4921 45.9562)",
    fill: "#0884CC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 69.8416,
    y: 33.5902,
    width: 9,
    height: 4,
    rx: 2,
    transform: "rotate(153.839 69.8416 33.5902)",
    fill: "#0884CC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4569,
    y: 34.3103,
    width: 27.8366,
    height: 1.29472,
    rx: 0.647361,
    transform: "rotate(90 96.4569 34.3103)",
    fill: "#0884CC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5573,
    y: 88.6886,
    width: 3.23681,
    height: 1.29472,
    rx: 0.647362,
    transform: "rotate(90 59.5573 88.6886)",
    fill: "#0884CC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5573,
    y: 84.1571,
    width: 3.23681,
    height: 1.29472,
    rx: 0.647362,
    transform: "rotate(90 59.5573 84.1571)",
    fill: "#0884CC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5573,
    y: 79.6255,
    width: 3.23681,
    height: 1.29472,
    rx: 0.647362,
    transform: "rotate(90 59.5573 79.6255)",
    fill: "#0884CC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5573,
    y: 75.094,
    width: 3.23681,
    height: 1.29472,
    rx: 0.647362,
    transform: "rotate(90 59.5573 75.094)",
    fill: "#0884CC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1519,
    y: 53.7311,
    width: 16.184,
    height: 1.29472,
    rx: 0.647361,
    transform: "rotate(90 73.1519 53.7311)",
    fill: "#0884CC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0308,
    y: 91.9255,
    width: 22.0103,
    height: 1.29472,
    rx: 0.647361,
    transform: "rotate(-180 66.0308 91.9255)",
    fill: "#0884CC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1519,
    y: 70.5626,
    width: 15.5367,
    height: 1.29472,
    rx: 0.647361,
    transform: "rotate(-180 73.1519 70.5626)",
    fill: "#0884CC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 104.225,
    y: 35.6049,
    width: 9.06306,
    height: 1.29472,
    rx: 0.647361,
    transform: "rotate(-180 104.225 35.6049)",
    fill: "#0884CC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 104.225,
    y: 62.1469,
    width: 9.06306,
    height: 1.29472,
    rx: 0.647361,
    transform: "rotate(-180 104.225 62.1469)",
    fill: "#0884CC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8093,
    y: 48.5522,
    width: 29.7786,
    height: 1.29472,
    rx: 0.64736,
    transform: "rotate(-180 95.8093 48.5522)",
    fill: "#0884CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0688 74.6085C58.4425 73.9612 59.3769 73.9612 59.7507 74.6085V74.6085C60.1244 75.2559 59.6572 76.0651 58.9097 76.0651V76.0651C58.1622 76.0651 57.695 75.2559 58.0688 74.6085V74.6085Z",
    fill: "#0884CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6634 53.2456C72.0371 52.5983 72.9715 52.5983 73.3453 53.2456V53.2456C73.719 53.893 73.2518 54.7022 72.5043 54.7022V54.7022C71.7568 54.7022 71.2896 53.893 71.6634 53.2456V53.2456Z",
    fill: "#0884CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.711 34.1168C105.358 34.4905 105.358 35.4249 104.711 35.7987V35.7987C104.063 36.1724 103.254 35.7052 103.254 34.9577V34.9577C103.254 34.2102 104.063 33.743 104.711 34.1168V34.1168Z",
    fill: "#0884CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.711 60.6585C105.358 61.0323 105.358 61.9667 104.711 62.3404V62.3404C104.063 62.7142 103.254 62.247 103.254 61.4995V61.4995C103.254 60.7519 104.063 60.2848 104.711 60.6585V60.6585Z",
    fill: "#0884CC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5163 90.4371C67.1637 90.8108 67.1637 91.7452 66.5163 92.119V92.119C65.869 92.4927 65.0598 92.0255 65.0598 91.278V91.278C65.0598 90.5305 65.869 90.0633 66.5163 90.4371V90.4371Z",
    fill: "#0884CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyConditions);
export default __webpack_public_path__ + "static/media/empty-conditions.d23a76f1370a16b88fa217ef926cf308.svg";
export { ForwardRef as ReactComponent };